// extracted by mini-css-extract-plugin
export default {"MultiCheckbox":"MultiCheckbox_MultiCheckbox__FqVnG"};